import { createCanvas } from '@/utils/helpers/train-simulation/create-canvas';

export const CreateStationMarkerAtlas = () => {
  const scale = 4;
  const baseSize = 20;
  const size = baseSize * scale;
  const res = createCanvas(size, size);

  if (!res || !res.ctx) {
    return '';
  }

  const { ctx, canvas } = res;

  ctx.scale(scale, scale);

  const centerX = baseSize / 2;
  const centerY = baseSize / 2;

  ctx.beginPath();
  ctx.arc(centerX, centerY, 8, 0, Math.PI * 2);
  ctx.fillStyle = '#ffffff';
  ctx.fill();

  ctx.beginPath();
  ctx.arc(centerX, centerY, 8, 0, Math.PI * 2);

  ctx.fillStyle = '#ffffff';
  ctx.fill();

  ctx.lineWidth = 2;
  ctx.strokeStyle = '#A9A9A9';
  ctx.stroke();

  return canvas.toDataURL();
};
